module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_030.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_030.png
// module id = 2346
// module chunks = 5